import { ChangeEventHandler, useMemo, useState } from 'react';

import { useUpdateVenueMutation } from '@admin/mutations/VenuesMutations';

import { useAppSettingsQuery } from '@queries/AppQueries';
import { FeedEvent, UserEventRsvp, useCurrentUserEventRsvpsQuery } from '@queries/EventQueries';
import { Series, useSeriesByTagId } from '@queries/TagQueries';
import { SuperAdminVenue, useCityVenuesQuery } from '@queries/VenueQueries';

import { useRsvpToEventMutation } from '@mutations/EventMutations';

import { Input } from '@components/form/Input';
import { Select } from '@components/form/Select';
import { Toggle } from '@components/form/Toggle';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

const EventItem = ({
  event,
  userEventRsvp,
  options = [],
  onUpdate,
}: {
  event: FeedEvent;
  userEventRsvp?: UserEventRsvp;
  options: string[];
  onUpdate: () => void;
}) => {
  const { rsvpToEventAsync } = useRsvpToEventMutation();

  const selectOptions = useMemo(() => {
    return [
      { value: '', label: '--' },
      ...options.map((option) => ({ value: option, label: option })),
    ];
  }, [options]);

  const value = useMemo(() => {
    return options.find((option) => userEventRsvp?.interested?.includes(option)) ?? '';
  }, [userEventRsvp]);

  const onChange: ChangeEventHandler<HTMLSelectElement> = async (e) => {
    await rsvpToEventAsync({
      eventId: event._id,
      interested: [e.target.value],
    });
    onUpdate();
  };

  return (
    <div>
      <div className="d-flex gap-2 align-items-center justify-content-between">
        <div>
          <div>
            <strong>{event.title}</strong>
          </div>
          <div style={{ fontSize: '.8rem', opacity: 0.8 }}>
            <div>{event.start}</div>
            <div>{event.venue?.title}</div>
          </div>
        </div>
        <div>
          <Select value={value} options={selectOptions} onChange={onChange} />
        </div>
      </div>
    </div>
  );
};

export const CategorizeExistingEventsList = ({ events }: { events: FeedEvent[] }) => {
  const { appSettings } = useAppSettingsQuery();
  const { eventRsvps } = useCurrentUserEventRsvpsQuery();

  return (
    <>
      <div className="d-grid gap-2">
        {events.map((event) => (
          <EventItem
            key={event._id}
            event={event}
            userEventRsvp={eventRsvps[event._id]}
            options={appSettings?.dragShowCategories}
            onUpdate={() => {}}
          />
        ))}
      </div>
    </>
  );
};
